import React, { useState, useEffect, useCallback } from 'react';
import { InputNumber } from 'antd';
import { Button, Message } from '@alifd/next';
import client from '@/lib/feathers';
import { Container } from './styles';

const EditBalance: React.FC = () => {
  const [balance, setBalance] = useState(0);
  const [trigger, setTrigger] = useState({});

  useEffect(() => {
    const getBalance = async () => {
      try {
        const res = await client
          .service('communityData')
          .find({ query: { $select: ['repairBalance'] } });
        setBalance(res.data[0].repairBalance);
      } catch (err) {
        console.error(err);
      }
    };
    getBalance();
  }, [trigger]);

  const handleEdit = useCallback(async () => {
    try {
      await client.service('communityData').patch(null, {
        repairBalance: balance,
      });
      setTrigger({});
      Message.success('保存成功');
    } catch (err) {
      console.error(err);
      Message.error('保存失敗');
    }
  }, [balance]);

  return (
    <Container>
      經費累計金額：
      <InputNumber
        value={balance}
        formatter={(val) => `${val?.toLocaleString()}`}
        onChange={(val) => setBalance(val)}
      />
      元<Button onClick={handleEdit}>保存</Button>
    </Container>
  );
};

export default EditBalance;
